import type { StoreApi } from 'zustand/vanilla';

import type { ActionResult, AppState } from './appState';

export const ACTION_OK: ActionResult = { ok: true };

export function actionError(message: string): { readonly ok: false; readonly message: string } {
  return { ok: false, message };
}

export interface AppStoreActionContext {
  readonly get: StoreApi<AppState>['getState'];
  readonly set: StoreApi<AppState>['setState'];
}
